import React from "react";
import DdiItem from "./ddi_item";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const DdiList = ({ list, showHeader = true, patientControls, groupCategory = null }) => {
  const { t } = useTranslation();
  return (
    <Container fluid className="ddi-list-container scroll-shadows justify-content-center">
      <table className="ddi-tbl mt-3 mb-5">
        {showHeader && (
          <thead className="ddi-list sticky-top">
            <tr>
              <th></th>
              <th>{t("auto.abema", "Abema")}<span style={{ fontSize: "0.9em", fontWeight: "400" }}>{t("auto.ciclib", "ciclib")}</span>
              </th>
              <th>{t("auto.palbo", "Palbo")}<span style={{ fontSize: "0.9em", fontWeight: "400" }}>{t("auto.ciclib", "ciclib")}</span>
              </th>
              <th>{t("auto.ribo", "Ribo")}<span style={{ fontSize: "0.9em", fontWeight: "400" }}>{t("auto.ciclib", "ciclib")}</span>
              </th>
            </tr>
          </thead>
        )}
        <tbody>
          {list?.map((element, idx) => {
            return <DdiItem data={element} key={idx} patientControls={patientControls} groupCategory={groupCategory} />;
          })}
        </tbody>
      </table>
    </Container>
  );
};

export default DdiList;
